import React, { useState } from 'react';
import { Button, Image, Modal, Grid } from 'semantic-ui-react';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const textStyleTotal = { fontSize: '1.5em' };
const textStyle = { fontSize: '1.2em' };

const CartModal = ({ user, cart, sendOrder, resetCart, onOrderSubmitted }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  const closeModal = () => {
    if (!sending) setModalOpen(false);
  };

  const sendOrderFromModal = async () => {
    setSending(true);
    setError('');
    let result;
    try {
      result = await sendOrder(user.token, cart.items);
      resetCart();
      setModalOpen(false);
    } catch (requestError) {
      setError('We could not send your order. Please try again or contact Dotline Design.');
    } finally {
      setSending(false);
    }
    if (result) onOrderSubmitted(result);
  };

  return (
    <>
      <Modal
        trigger={<Button primary disabled={cart.items.length < 1} onClick={() => setModalOpen(true)}>Checkout</Button>}
        closeOnDimmerClick={false}
        size='large'
        closeIcon={!sending}
        open={modalOpen}
        onClose={closeModal}
      >
        <Modal.Header>Confirm your order {user.username}</Modal.Header>
        <Modal.Content scrolling>
          <Grid columns={2} divided="vertically" verticalAlign='middle'>
            {cart.items.map((item, i) => (
              <Grid.Row key={i}>
                <Grid.Column><Image centered size='small' src={item.url} /></Grid.Column>
                <Grid.Column>
                  <div className="header" style={textStyle}>{item.name} - {item.description}</div>
                  <div style={textStyle}>Quantity: {item.quantity}</div>
                  <div style={textStyle}>Price: {formatter.format(item.price)}</div>
                  <div style={textStyle}>Size: {item.size}</div>
                  <div style={textStyle}>Color: {item.color}</div>
                </Grid.Column>
              </Grid.Row>
            ))}
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          {error && <div className="ui negative message" role="alert">{error}</div>}
          <div className="ui header" style={textStyleTotal}>Total: {formatter.format(cart.total)}</div>
          <h3>Total does not include HST and Shipping</h3>
          <Button negative disabled={sending} onClick={closeModal}>Cancel</Button>
          <Button positive loading={sending} disabled={sending} onClick={sendOrderFromModal}>Send Order</Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default CartModal;
